export const getTryMeDemoNotification = (username) => ({
    id: 'dummy',
    type: 'notifications',
    sub_type: 'try_live',
    is_read: true,
    updated_at: Math.round(Date.now() / 1000),
    msg_params: { user: username },
});
